import * as React from "react";
import { Card } from "antd";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { kindMetadata } from "../../../services/kindMetadata";
import { PolicyQueryAgent } from "./agent";
import { PolicyQueryAuditContext } from "./auditctx";
import { PolicyQueryCloudAccount } from "./cloudaccount";
import { PolicyQueryDomain } from "./domain";
import { PolicyQueryGroup } from "./group";
import { PolicyQueryGvc } from "./gvc";
import { PolicyQueryIdentity } from "./identity";
import { PolicyQueryImage } from "./image";
import { PolicyQueryIpSet } from "./ipset";
import { PolicyQueryLocation } from "./location";
import { PolicyQueryKubernetes } from "./mk8s";
import { PolicyQueryPolicy } from "./policy";
import { PolicyQueryQuota } from "./quota";
import { PolicyQuerySecret } from "./secret";
import { PolicyQueryServiceAccount } from "./serviceaccount";
import { PolicyQueryUser } from "./user";
import { PolicyQueryVolumeSet } from "./volumeset";
import { PolicyQueryWorkload } from "./workload";
import { useAppSelector } from "../../../store/hooks";
import { selectOrg } from "../../../store/contextSlice";
import { useCpFormValue } from "../../gvc/testNewForm/utils";
import { CpErrorWarningArrayIcon } from "../../gvc/testNewForm/CpErrorWarningArrayIcon";

interface Props {}
export const TargetQuery: React.FC<Props> = ({}) => {
  const org = useAppSelector(selectOrg);

  const targetKind = useCpFormValue(`targetKind`);
  const targetAll = useCpFormValue(`targetAll`);

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>
            <div className={`flex items-center`}>
              <div>{kindMetadata[targetKind as any].name} Query</div>
              <div style={{ transform: "translateY(0px)" }}>
                <CpErrorWarningArrayIcon names={["targetQuery"]} />
              </div>
            </div>
          </CardTitle>
          {targetKind === "org" ? (
            <div>Policy target is this org ({org}) itself.</div>
          ) : targetKind === "task" ? (
            <div>Policy target is all tasks in this org ({org}).</div>
          ) : targetAll ? (
            <div>Policy target is "all", no need to target items with a query, all items of this org is targeted.</div>
          ) : (
            <>
              {targetKind === "agent" ? <PolicyQueryAgent /> : null}
              {targetKind === "auditctx" ? <PolicyQueryAuditContext /> : null}
              {targetKind === "cloudaccount" ? <PolicyQueryCloudAccount /> : null}
              {targetKind === "domain" ? <PolicyQueryDomain /> : null}
              {targetKind === "group" ? <PolicyQueryGroup /> : null}
              {targetKind === "gvc" ? <PolicyQueryGvc /> : null}
              {targetKind === "identity" ? <PolicyQueryIdentity /> : null}
              {targetKind === "image" ? <PolicyQueryImage /> : null}
              {targetKind === "ipset" ? <PolicyQueryIpSet /> : null}
              {targetKind === "location" ? <PolicyQueryLocation /> : null}
              {targetKind === "mk8s" ? <PolicyQueryKubernetes /> : null}
              {targetKind === "policy" ? <PolicyQueryPolicy /> : null}
              {targetKind === "quota" ? <PolicyQueryQuota /> : null}
              {targetKind === "secret" ? <PolicyQuerySecret /> : null}
              {targetKind === "serviceaccount" ? <PolicyQueryServiceAccount /> : null}
              {targetKind === "user" ? <PolicyQueryUser /> : null}
              {targetKind === "volumeset" ? <PolicyQueryVolumeSet /> : null}
              {targetKind === "workload" ? <PolicyQueryWorkload /> : null}
            </>
          )}
        </Card>
      </div>
    </>
  );
};
